import gql from 'graphql-tag';
import {
    SUPPLY_ORDER_DETAILS_FRAGMENT,
    SUPPLY_ORDER_FRAGMENT,
    SUPPLY_ORDER_PRODUCT_ISSUE_FRAGMENT,
    SUPPLY_ORDER_PRODUCT_STOCK_VARIATION_FRAGMENT,
    SUPPLY_ORDER_PRODUCT_TO_ADD_FRAGMENT,
} from '../fragments/supplyOrder';

export const GET_SUPPLY_ORDERS_QUERY = gql`
    query GET_SUPPLY_ORDERS($displayLimitDateFormatted: String) {
        supplyOrders(displayLimitDateFormatted: $displayLimitDateFormatted) {
            ...SupplyOrderFragment
            description
            isAtSoldOutRisk
            isMerged
            issues {
                ...SupplyOrderProductIssueFragment
            }
            products {
                _id
                quantity
                supplyOrderId
            }
        }
    }
    ${SUPPLY_ORDER_FRAGMENT}
    ${SUPPLY_ORDER_PRODUCT_ISSUE_FRAGMENT}
`;

/** Requête d'ouverture de la fiche d'achat : un `getById` et trois dataloaders, rien de plus. */
export const GET_SUPPLY_ORDER_DETAILS_QUERY = gql`
    query GET_SUPPLY_ORDER_DETAILS($supplyOrderId: String!) {
        supplyOrder(supplyOrderId: $supplyOrderId) {
            ...SupplyOrderDetailsFragment
        }
    }
    ${SUPPLY_ORDER_DETAILS_FRAGMENT}
`;

/** Section « Prévisions et variations de stock » — chargée à l'ouverture de la section. */
export const GET_SUPPLY_ORDER_SUPPLIER_PRODUCTS_STOCK_VARIATION_QUERY = gql`
    query GET_SUPPLY_ORDER_SUPPLIER_PRODUCTS_STOCK_VARIATION($supplyOrderId: String!) {
        supplyOrderSupplierProductsStockVariation(supplyOrderId: $supplyOrderId) {
            productGroupStockVariations {
                ...SupplyOrderProductStockVariationFragment
                isComputed
            }
            supplyOrderStockVariations {
                ...SupplyOrderProductStockVariationFragment
                isComputed
            }
        }
    }
    ${SUPPLY_ORDER_PRODUCT_STOCK_VARIATION_FRAGMENT}
`;

/** Section « Produits à commander » — le catalogue moins ce qui est déjà sur l'achat, à la demande. */
export const GET_SUPPLY_ORDER_PRODUCTS_TO_ADD_QUERY = gql`
    query GET_SUPPLY_ORDER_PRODUCTS_TO_ADD($supplyOrderId: String!) {
        supplyOrderProductsToAdd(supplyOrderId: $supplyOrderId) {
            ...SupplyOrderProductToAddFragment
        }
    }
    ${SUPPLY_ORDER_PRODUCT_TO_ADD_FRAGMENT}
`;

/**
 * Section « Historique de livraison du fournisseur » — chargée à l'ouverture de la section.
 * Sélection maigre par construction : le serveur ne renvoie que des dates, pas des achats.
 */
export const GET_SUPPLIER_DELIVERY_HISTORY_QUERY = gql`
    query GET_SUPPLIER_DELIVERY_HISTORY($supplierId: String!, $limit: Int) {
        supplierDeliveryHistory(supplierId: $supplierId, limit: $limit) {
            _id
            number
            state
            orderDate
            initialDeliveryDate
            scheduledDeliveryDate
            deliveryDate
            storedDate
        }
    }
`;

export const GET_PRODUCTS_TO_ORDER_ONCE_FOR_SUPPLY_ORDER_QUERY = gql`
    query GET_PRODUCTS_TO_ORDER_ONCE_FOR_SUPPLY_ORDER($supplyOrderId: String!) {
        productsToOrderOnceForSupplyOrder(supplyOrderId: $supplyOrderId) {
            _id
            suppliers {
                prices {
                    packagesPerBatch
                }
            }
        }
    }
`;
